<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="具体课程" prop="videoCourseIds">
              <!-- <el-input type="number" v-model="searchForm.videoCourseId" auto-complete="off"></el-input> -->
              <el-cascader
                style="width:100%"
                clearable
                v-model="videoCourseIds"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请输入所属科目"
                :options="subjectTreeList"
                @change="subjectSearchChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="收费模式" prop="type">
              <el-select style="width:100%" v-model="searchForm.type" clearable placeholder="请选择">
                <el-option label="免费" value="免费"></el-option>
                <el-option label="会员" value="会员"></el-option>
                <el-option label="付费" value="付费"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="视频状态" prop="enabled">
              <!-- <el-input type="number" v-model="searchForm.enabled" auto-complete="off"></el-input> -->
              <!-- <el-radio-group v-model="searchForm.enabled">
                <el-radio label>全部</el-radio>
                <el-radio label="1">启用</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>-->
              <el-select
                style="width:100%"
                v-model="searchForm.enabled"
                clearable
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="视频名称" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入名称" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="时间">
              <el-date-picker
                style="width:100%"
                v-model="createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="timeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12" style="float:right">
            <el-button-group style="float:right">
              <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
              <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
              <!-- <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">批量导入</el-button> -->
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
          <!-- <el-button type="danger" @click="batchDeleteVideoInfo" icon="el-icon-minus">批量删除</el-button> -->
        </el-col>
        <el-col style="text-align: right" :span="12">
          <!-- <el-button style="text-align: right" type="primary" @click="exportExcel" :loading="loading" icon="el-icon-upload2">导出</el-button> -->
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
        v-loading="videoInfoLoading"
        element-loading-text="拼命加载中..."
      >
        <el-table-column prop="type" label="收费模式" width="80">
          <template slot-scope="row">
            <span v-if="row.row.type=='免费'" class="free">{{row.row.type}}</span>
            <span v-if="row.row.type=='会员'" class="member">{{row.row.type}}</span>
            <span v-if="row.row.type=='付费'" class="fee">{{row.row.type}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="videoCourseName" label="具体课程" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="视频名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="duration" label="时长"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="playCount" label="播放"></el-table-column>
        <el-table-column prop="createTime" label="上传时间"></el-table-column>
        <el-table-column prop="enabled" label="状态" width="70" align="center">
          <template style="text-align:center" slot-scope="row">
            <el-switch
              v-model="row.row.enabled"
              active-value="1"
              inactive-value="0"
              @change="updateSwitching(row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click="selection = scope.row.id, editFormVisible = true"
              ></i>
              <i class="iconfont iconyulan mainColor" title="预览" @click="previewVideo(scope.row)"></i>
            </div>
            <!-- <el-button
              type="text"
              size="small"
              @click="selection = scope.row.id, editFormVisible = true"
            >编辑</el-button>
            <el-button type="text" size="small" @click="previewVideo(scope.row)">预览</el-button>-->
            <!-- <el-button type="text" size="small" @click="deleteVideoInfo(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="添加视频"
      :visible.sync="addFormVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="所属科目">
              <!-- <el-input type="number" v-model="addForm.videoCourseId" placeholder="请输入所属视频课程id" auto-complete="off" maxlength="19"></el-input> -->
              <el-cascader
                style="width:100%"
                clearable
                v-model="addForm.courseId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请输入所属科目"
                :options="subjectTreeList"
                @change="subjectChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="具体课程" prop="id">
              <el-select style="width:100%" v-model="addForm.videoCourseId" placeholder="请选择">
                <el-option
                  v-for="item in videoCourseTree"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入名称"
                auto-complete="off"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                type="number"
                v-model="addForm.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="18" :md="8" :lg="8">
            <el-form-item label="收费模式" prop="type">
              <!-- <el-input v-model="addForm.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
              <el-radio-group v-model="addForm.type" size="small" @change="typeChange">
                <el-radio label="免费">免费</el-radio>
                <el-radio label="会员">会员</el-radio>
                <el-radio label="付费">付费</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :sm="6" :md="4" :lg="4">
            <el-input :disabled="priceDisabled" v-model="addForm.price" maxlength="18">
              <template slot="append">元</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频id" prop="tencentVideoId">
              <el-input
                v-model="addForm.tencentVideoId"
                placeholder="请输入腾讯视频id"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="腾讯appid" prop="tencentAppid">
              <el-input
                v-model="addForm.tencentAppid"
                placeholder="请输入腾讯appid"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="播放次数" prop="playCount">
              <el-input
                v-model="addForm.playCount"
                placeholder="请输入播放次数"
                auto-complete="off"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="播放时长" prop="duration">
              <el-input
                v-model="addForm.duration"
                placeholder="请输入播放时长"
                auto-complete="off"
                maxlength="11"
              >
                <template slot="append">秒</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频地址" prop="url">
              <el-input
                v-model="addForm.url"
                placeholder="请输入视频地址"
                auto-complete="off"
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="是否开启" prop="enabled">
              <!-- <el-input type="number" v-model="addForm.enabled" placeholder="请输入开启 1开启" auto-complete="off" maxlength="10"></el-input> -->
              <el-radio-group v-model="addForm.enabled">
                <el-radio label="1">启用</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="视频说明" prop="remark">
              <el-input
                type="textarea"
                v-model="addForm.remark"
                placeholder="请输入视频说明"
                auto-complete="off"
                maxlength="300"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addVideoInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑视频"
      :visible.sync="editFormVisible"
      width="900px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="所属科目" prop="courseId">
              <!-- <el-input type="number" v-model="addForm.videoCourseId" placeholder="请输入所属视频课程id" auto-complete="off" maxlength="19"></el-input> -->
              <el-cascader
                style="width:100%"
                clearable
                v-model="editForm.courseId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请输入所属科目"
                :options="subjectTreeList"
                @change="subjectEditChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="具体课程" prop="videoCourseId">
              <el-select style="width:100%" v-model="editForm.videoCourseId" placeholder="请选择">
                <el-option
                  v-for="item in videoCourseTree"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频名称" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入名称"
                auto-complete="off"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                type="number"
                v-model="editForm.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="18" :md="8" :lg="8">
            <el-form-item label="收费模式" prop="type">
              <!-- <el-input v-model="addForm.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
              <el-radio-group v-model="editForm.type" size="small" @change="typeEditChange">
                <el-radio label="免费">免费</el-radio>
                <el-radio label="会员">会员</el-radio>
                <el-radio label="付费">付费</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :sm="6" :md="4" :lg="4">
            <el-input :disabled="priceEditDisabled" v-model="editForm.price" maxlength="18">
              <template slot="append">元</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频id" prop="tencentVideoId">
              <el-input
                v-model="editForm.tencentVideoId"
                placeholder="请输入腾讯视频id"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="腾讯appid" prop="tencentAppid">
              <el-input
                v-model="editForm.tencentAppid"
                placeholder="请输入腾讯appid"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="播放次数" prop="playCount">
              <el-input
                v-model="editForm.playCount"
                placeholder="请输入播放次数"
                auto-complete="off"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="播放时长" prop="duration">
              <el-input
                v-model="editForm.duration"
                placeholder="请输入播放时长"
                auto-complete="off"
                maxlength="11"
              >
                <template slot="append">秒</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频地址" prop="url">
              <el-input
                v-model="editForm.url"
                placeholder="请输入视频地址"
                auto-complete="off"
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="是否开启" prop="enabled">
              <!-- <el-input type="number" v-model="addForm.enabled" placeholder="请输入开启 1开启" auto-complete="off" maxlength="10"></el-input> -->
              <el-radio-group v-model="editForm.enabled">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="视频说明" prop="remark">
              <el-input
                type="textarea"
                v-model="addForm.remark"
                placeholder="请输入视频说明"
                auto-complete="off"
                maxlength="300"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: right"
        :close-on-click-modal="false"
      >
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateVideoInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="videoTitle"
      :visible.sync="videoDialog"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </el-dialog>
    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      width="80%"
      left
      :close-on-click-modal="false"
    >
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.data"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="videoCourseName" label="具体课程"></el-table-column>
        <el-table-column prop="name" label="视频名称"></el-table-column>
        <el-table-column prop="duration" label="时长（秒）"></el-table-column>
        <el-table-column prop="type" label="收费模式"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="excelDataState" label="是否通过"></el-table-column>
        <el-table-column prop="excelDataFailReason" label="原因"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      videoDialog: false,
      videoInfoLoading: true,
      createTime: "",
      videoCourseIds: [],
      searchForm: {
        type: "",
        enabled: "",
        createTimeBegin: "",
        createTimeEnd: "",
        name: ""
      },
      addForm: {
        videoCourseId: "",
        name: "",
        courseId: "",
        sort: "",
        type: "免费",
        price: "",
        tencentVideoId: "",
        tencentAppid: "",
        enabled: "1",
        url: "",
        remark: "",
        playCount: "",
        duration: ""
      },
      addFormRules: {
        videoCourseId: [
          {
            required: true,
            message: "请输入所属视频课程id",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字"
          }
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择类别：免费/付费/会员",
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ],
        tencentVideoId: [
          {
            required: true,
            message: "请输入腾讯视频id",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "腾讯视频id长度在1到50个字"
          }
        ],
        tencentAppid: [
          {
            required: true,
            message: "请输入腾讯appid",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "腾讯appid长度在1到50个字"
          }
        ],
        enabled: [
          {
            required: true,
            message: "请输入开启 1开启",
            trigger: "change"
          }
        ],
        url: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur"
          },
          {
            min: 1,
            max: 500,
            message: "视频地址长度在1到500个字"
          }
        ],
        playCount: [
          {
            required: true,
            message: "请输入播放次数",
            trigger: "blur"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入播放时长",
            trigger: "blur"
          }
        ]
      },
      editForm: {
        videoCourseId: "",
        courseId: "",
        name: "",
        sort: "",
        type: "",
        price: "",
        tencentVideoId: "",
        tencentAppid: "",
        url: "",
        remark: "",
        enabled: ""
      },
      editFormRules: {
        videoCourseId: [
          {
            required: true,
            message: "请输入所属视频课程id",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属视频课程id格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字"
          }
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确"
          }
        ],
        type: [
          {
            required: true,
            message: "请输入类别：免费/付费/会员",
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ],
        tencentVideoId: [
          {
            required: true,
            message: "请输入腾讯视频id",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "腾讯视频id长度在1到50个字"
          }
        ],
        tencentAppid: [
          {
            required: true,
            message: "请输入腾讯appid",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "腾讯appid长度在1到50个字"
          }
        ],
        url: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur"
          },
          {
            min: 1,
            max: 500,
            message: "视频地址长度在1到500个字"
          }
        ],
        enabled: [
          {
            required: true,
            message: "请输入开启 1开启",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "开启 1开启格式不正确"
          }
        ],
        playCount: [
          {
            required: true,
            message: "请输入播放次数",
            trigger: "blur"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入播放时长",
            trigger: "blur"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/videoInfo/importExcelCheck`,
      fileList: [],
      loading: false,
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      videoCourseTree: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      videoTitle: "",
      priceDisabled: true,
      priceEditDisabled: true
    };
  },
  methods: {
    subjectSearchChange() {
      if (this.videoCourseIds.length > 0) {
        this.searchForm.videoCourseIds[0] = this.videoCourseIds[2];
      } else {
        this.searchForm.videoCourseIds = [];
      }
    },
    typeEditChange() {
      if (this.editForm.type == "付费") {
        this.priceEditDisabled = false;
      } else {
        this.priceEditDisabled = true;
      }
    },
    typeChange() {
      if (this.addForm.type == "付费") {
        this.priceDisabled = false;
      } else {
        this.priceDisabled = true;
      }
    },
    updateSwitching(row) {
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled
      };
      this.api.videoInfo.updateVideoInfo(obj).then(result => {
        if (result.success) {
          this.$message.success(result.message);
          this.pageList();
        } else {
          this.pageList();
          this.$message.error(result.message);
        }
      });
    },
    timeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    previewVideo(vId) {
      this.videoTitle = "视频名称：" + vId.name;
      this.playerOptions.sources[0].src = vId.url;
      this.videoDialog = true;
    },
    closeDialog() {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getVideoInfo() {
      this.api.videoInfo
        .getVideoInfo({ id: this.selection })
        .then(result => {
          this.editForm.courseId = result.data.courseId;
          this.api.videoCourse
            .getVideoCourseTree({ courseId: this.editForm.courseId })
            .then(row => {
              this.videoCourseTree = row.data;
            });
          this.editForm = result.data;
          if (this.editForm.price == "付费") {
            this.priceEditDisabled = false;
          } else {
            this.priceEditDisabled = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.videoInfo
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          for (let i in this.page.rows) {
            this.page.rows[i].enabled = String(this.page.rows[i].enabled);
          }
          this.videoInfoLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    subjectChange() {
      this.addForm.courseId = this.addForm.courseId[2];
      this.api.videoInfo
        .getVideoCourseTree({ courseId: this.addForm.courseId })
        .then(result => {
          this.videoCourseTree = result.data;
        });
      this.addForm.courseId = "";
    },
    subjectEditChange() {
      this.editForm.courseId = this.editForm.courseId[2];
      this.api.videoInfo
        .getVideoCourseTree({ courseId: this.editForm.courseId })
        .then(result => {
          this.videoCourseTree = result.data;
        });
      this.editForm.courseId = "";
    },
    addVideoInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.videoInfo
            .addVideoInfo(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateVideoInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.videoInfo
            .updateVideoInfo(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteVideoInfo(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.videoInfo
            .deleteVideoInfo([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteVideoInfo() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.videoInfo
            .deleteVideoInfo(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.loading = true;
      this.$refs.searchForm.resetFields();
      this.videoCourseIds = [];
      this.createTime = [];
      this.searchForm.createTimeBegin = "";
      this.searchForm.createTimeEnd = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      console.log("response", response);
      this.importForm = response;
    },
    exportExcel() {
      this.loading = true;
      this.api.videoInfo
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.videoInfo
        .importData(this.importForm.data)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getVideoInfo();
      }
    }
  },
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>
<style scoped>
.free {
  padding: 3px 14px 3px 14px;
  color: #fff;
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
  text-align: center;
  border-radius: 4px;
}
.member {
  padding: 3px 14px 3px 14px;
  color: #fff;
  background: rgb(255, 177, 2);
  border: solid 1px rgb(255, 177, 2);
  text-align: center;
  border-radius: 4px;
}
.fee {
  padding: 3px 14px 3px 14px;
  color: #fff;
  background: rgb(255, 100, 107);
  border: solid 1px rgb(255, 100, 107);
  text-align: center;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/videoInfo/index.vue